import axios from './http'
import Qs from 'qs'
import vm from './main'

let urls = {
    login:'/login',    //登陆

    getUserList:'/user/getlist',
    getUserById:'/user/getone',
    saveUser:'/user/save',
    updateUser:'/user/update',
    deleteUser:'/user/remove',
    getAllUser:'/user/getall',

    getWebsiteList:'/website/getlist',
    getWebsiteById:'/website/getone',
    saveWebsite:'/website/save',
    updateWebsite:'/website/update',
    deleteWebsite:'/website/remove',
    getAllWebsite:'/website/getall',
    
}

//包装get
let getMethod = (url,query) => axios.get(url + '?' + Qs.stringify(query))

let postMethod = (url,query) => axios.post(url , query)//包装post

let post = async function(reqUrl,query,selfHandle){
    console.log(reqUrl)
    if('login'.indexOf(reqUrl) == -1 && localStorage.token){//登录api不需要检查token
        if(query){
            query.token = localStorage.token;
        }else{
            query = {
                token : localStorage.token
            }
        }
    }
    let res = null;
    try{//捕捉请求异常并提示错误
        res = await postMethod(urls[reqUrl],query);
    }catch(e){
        vm.$notify({ message: '远程服务器失联了，请检查您的网络！', type: 'error'});
        return null;
    }
    if(res.data.code == '400' && 'login'.indexOf(reqUrl) == -1){//token失效
        vm.$notify({ message: '身份认证失效,请重新登录！', type: 'error'});
        localStorage.clear();
        sessionStorage.hasBar = 0;
        vm.$router.push({path:'/login'});
        return null;
    }else if(res.data.code != '0'){//其他错误
        if(selfHandle){
            return res;
        }else {
            vm.$notify({ message: res.data.msg, type: 'error'});
            return null;
        }
    }
    else{//正常的情况
        return res;
    }
};

export default {
    post:post,
    url:axios.defaults.baseURL,
}